import React, { useState, useEffect } from "react";

const Gallery = () => {
  const [filter, setFilter] = useState("all");
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryItems = [
    {
      id: 1,
      src: "/img/transport1.avif",
      alt: "Luxury transport service",
      category: "transport",
    },
    {
      id: 2,
      src: "/img/shelf.webp",
      alt: "Carpentry workbench",
      category: "carpentry",
    },
    {
      id: 3,
      src: "/img/bed3.webp",
      alt: "Custom wooden bed frame",
      category: "carpentry",
    },
    {
      id: 4,
      src: "/img/rental.jpg",
      alt: "Vehicle rental fleet",
      category: "vehicle-rentals",
    },
    {
      id: 5,
      src: "/img/ward.jpg",
      alt: "Working hard to craft wooden table",
      category: "carpentry",
    },
    {
      id: 6,
      src: "/img/sofacum.webp",
      alt: "Wooden sofa cum bed, daybed, diwan for modern home",
      category: "carpentry",
    },
    {
      id: 7,
      src: "/img/shuttle1.jpg",
      alt: "Group shuttle service",
      category: "shuttle",
    },
    {
      id: 8,
      src: "/img/setup.webp",
      alt: "Wooden Chair",
      category: "carpentry",
    },
    {
      id: 9,
      src: "/img/bed2.webp",
      alt: "Custom wooden bed frame",
      category: "carpentry",
    },
  ];

  const categories = [
    { id: "all", name: "All" },
    { id: "carpentry", name: "CARPENTRY & JOINERY" },
    { id: "transport", name: "TRANSPORT & LOGISTICS " },
    { id: "shuttle", name: "AIRPORT TRANSFERS & SHUTTLES" },
    { id: "vehicle-rentals", name: "Vehicle Rentals" },
  ];

  const filteredItems =
    filter === "all"
      ? galleryItems
      : galleryItems.filter((item) => item.category === filter);

  const openModal = (item, index) => {
    setSelectedImage(item);
    setCurrentIndex(index);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const goToNext = () => {
    const nextIndex = (currentIndex + 1) % filteredItems.length;
    setSelectedImage(filteredItems[nextIndex]);
    setCurrentIndex(nextIndex);
  };

  const goToPrev = () => {
    const prevIndex =
      (currentIndex - 1 + filteredItems.length) % filteredItems.length;
    setSelectedImage(filteredItems[prevIndex]);
    setCurrentIndex(prevIndex);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;

      if (e.key === "Escape") {
        closeModal();
      }

      if (e.key === "ArrowRight") {
        goToNext();
      }

      if (e.key === "ArrowLeft") {
        goToPrev();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedImage, currentIndex]);

  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedImage]);

  return (
    <>
      {/* Filter Buttons */}
      <div className="flex flex-wrap justify-center gap-3 mb-10">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => setFilter(category.id)}
            className={`px-6 py-3 text-sm font-bold uppercase border-2 border-primary transition-all duration-250 ${
              filter === category.id
                ? "bg-primary text-white"
                : "bg-transparent text-white hover:bg-primary hover:text-white"
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Gallery Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredItems.slice(0, 6).map((item, index) => (
          <div
            key={item.id}
            className="relative overflow-hidden rounded-lg cursor-pointer group"
            onClick={() => openModal(item, index)}
          >
            <img
              src={item.src}
              alt={item.alt}
              className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
              <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="fas fa-search-plus text-white text-3xl"></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm animate-fadeIn"
          onClick={closeModal}
        >
          <button
            onClick={closeModal}
            className="absolute top-6 right-6 text-white text-4xl bg-black/50 rounded-full w-12 h-12 flex items-center justify-center hover:bg-primary transition-colors z-10"
          >
            &times;
          </button>

          <button
            onClick={goToPrev}
            className="absolute left-6 top-1/2 transform -translate-y-1/2 text-white text-4xl bg-black/50 rounded-full w-12 h-12 flex items-center justify-center hover:bg-primary transition-colors z-10"
          >
            <i className="fas fa-chevron-left"></i>
          </button>

          <button
            onClick={goToNext}
            className="absolute right-6 top-1/2 transform -translate-y-1/2 text-white text-4xl bg-black/50 rounded-full w-12 h-12 flex items-center justify-center hover:bg-primary transition-colors z-10"
          >
            <i className="fas fa-chevron-right"></i>
          </button>

          <div
            className="relative max-w-4xl max-h-[80vh] mx-4 transform transition-all duration-300 scale-100 opacity-100 animate-[modalZoom_0.3s_ease]"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="max-w-full max-h-[80vh] object-contain rounded"
            />
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-full">
              {currentIndex + 1} / {filteredItems.length}
            </div>
          </div>

          {/* Thumbnails */}
          <div
            className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2"
            onClick={(e) => e.stopPropagation()}
          >
            {filteredItems.map((item, index) => (
              <button
                key={item.id}
                onClick={() => {
                  setSelectedImage(item);
                  setCurrentIndex(index);
                }}
                className={`w-16 h-16 rounded overflow-hidden border-2 ${
                  currentIndex === index
                    ? "border-primary"
                    : "border-transparent"
                }`}
              >
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
